import * as administration from '../xhr/administration';
import * as notifier from './notifier';
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'container') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 *
 * @param filters
 * @param cursor
 * @returns {function(*): Promise<unknown>}
 */
export function getChangeRequests(filters, cursor) {
    if (!filters) {
        filters = {};
    }

    return (dispatch) => {
        setLoader(dispatch, true, 'modal');
        return administration.getAll(cursor, filters)
            .then((data) => {
                setLoader(dispatch, false, 'modal');
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false, 'modal');
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 * @param changeRequestID
 * @param body
 * @returns {function(*): Promise<*>}
 */
export function updateChangeRequest(changeRequestID, body) {
    return (dispatch) => {
        setLoader(dispatch, true, 'modal');
        return administration.update(changeRequestID, body)
            .then((data) => {
                setLoader(dispatch, false, 'modal');
                dispatch(notifier.displayMessage('Change request saved successfully!'));
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false, 'modal');
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 * @param changeRequestID
 * @returns {function(*): Promise<*>}
 */
export function resendReviewEmail(changeRequestID) {
    return (dispatch) => {
        setLoader(dispatch, true, 'modal');
        return administration.resendReviewEmail(changeRequestID)
            .then((data) => {
                setLoader(dispatch, false, 'modal');
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false, 'modal');
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 * @param changeRequestID
 * @returns {function(*): Promise<*>}
 */
export function getChangeRequestFile(changeRequestID) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return administration.getFile(changeRequestID)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 *
 * @returns {function(*): Promise<*>}
 * @param changeRequestID
 * @param changeRequestFile
 */
export function approveChangeRequest(changeRequestID, changeRequestFile) {
    return (dispatch) => {
        setLoader(dispatch, true, 'modal');
        return administration.approve(changeRequestID, changeRequestFile)
            .then((data) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayMessage('Change request approved successfully!'));
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error)); 
            });
    };
}

/**
 *
 * @returns {function(*): Promise<*>}
 * @param changeRequestID
 * @param changeRequestFile
 */
export function declineChangeRequest(changeRequestID, changeRequestFile) {
    return (dispatch) => {
        setLoader(dispatch, true, 'modal');
        return administration.decline(changeRequestID, changeRequestFile)
            .then((data) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayMessage('Change request declined successfully!'));
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error)); 
            });
    };
}

/**
 * 
 * @param changeRequestID 
 * @returns 
 */
export function downloadChangeRequestPdf(changeRequestID) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return administration.downloadChangeRequestPdf(changeRequestID)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}